<template>
  <div class="startConfigDiv">
    <sc-field-group ref="scFieldGroup" :fieldGroupName="fieldGroupName" :fieldGroup="fieldGroup" :specific-component="specificComponent" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ScFieldGroup from '../base/ScFieldGroup.vue';
import BaseForm from '../base/BaseForm.vue';

const { mapState, mapMutations } = createNamespacedHelpers(
  'integrations/integrationsAppSelfService',
);

export default {
  name: 'sc-config',
  components: {
    ScFieldGroup,
    BaseForm,
  },

  props: {
    fieldGroupName: {
      type: String,
      required: true,
    },
    fieldGroup: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      specificComponent: BaseForm,
    };
  },
  computed: {
    ...mapState(['appDetails', 'appConfig']),
  },
  methods: {
    ...mapMutations(['nextStep', 'setAppConfig']),

    refresh() {
      this.$refs.scFieldGroup.refresh();
    },
    validate() {
      return this.$refs.scFieldGroup.validate();
    },
    invalidate() {
      this.$refs.scFieldGroup.invalidate();
    },
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/components/config/ScConfig.vue